import { BaseContactDto } from '../../../shared/modules/base/dtos/base-contact.dto';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Third party contact DTO
 */
export class ThirdPartyContactDto extends BaseContactDto {}
